import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import HeaderLinks from "./HeaderLinks.jsx";
import logo from "assets/img/logo_rw.svg";
import logoSmall from "assets/img/logo_rw_small.svg";
import dashboardRoutes from "routes/dashboard.jsx";
import styled from 'styled-components';

const Line = styled.div`
  height: 36px;
  width: 0px;
  margin: 0px 20px;
  border-left: 1px solid #E3E3E3;
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.handleMinimizeSidebar = this.handleMinimizeSidebar.bind(this);
    this.state = {
      sidebarExists: false
    };
  }
  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }
  handleMinimizeSidebar() {
    document.body.classList.toggle('sidebar-mini');
  }

  render() {
    return (
      <Navbar fluid>
        <Navbar.Header>
          <Navbar.Brand>
            <a
              href="/"
              className="simple-text logo-mini"
            >
              <div className="logo-img">
                <img src={logo} alt="logo_image" id="logo_image" />
                <img src={logoSmall} alt="logo_image" id="logo_image_small" style={{ height: 40 }} />
              </div>
            </a>
            <Line />
            <a style={{color: '#fff', fontSize: '25px', padding: '9px 0'}}>ระบบตรวจสอบสถานะ Tracking </a>
          </Navbar.Brand>
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks {...this.props} />
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
